import {
  FLUSH, PAUSE, PERSIST, PURGE, REGISTER, REHYDRATE, persistStore, persistReducer,
} from 'redux-persist';
import * as Sentry from '@sentry/react';
import { configureStore } from '@reduxjs/toolkit';

import api from 'service/index';
import cameraMiddleware from 'modules/camera/middleware';
import appListenerMiddleware from 'modules/app/middleware';
import authListenerMiddleware from 'modules/auth/middleware';
import gatesListenerMiddleware from 'modules/gates/middleware';
import kioskListenerMiddleware from 'modules/kiosk/middleware';
import socketListenerMiddleware from 'modules/sockets/middleware';
import refDataListenerMiddleware from 'modules/refData/middleware';
import translationsMiddleware from 'modules/translations/middleware';
import onlinePaymentMiddleware from 'modules/onlinePayment/middleware';
import healthCheckListenerMiddleware from 'modules/healthCheck/middleware';
import selfServiceListenerMiddleware from 'modules/selfServices/middleware';
import navigationMiddleware from 'modules/router/navigationMiddleware';

import vehicleCheckListenerMiddleware from 'modules/vehicleCheck/middleware';

import rootReducer from './rootReducer';
import { persistConfig } from './persist';
import { listenerMiddleware } from './ListenerMiddleware';

const persistedReducer = persistReducer(persistConfig, rootReducer);

const sentryReduxEnhancer = Sentry.createReduxEnhancer();

const MIDDLEWARES = [
  api.middleware,
  navigationMiddleware,
  cameraMiddleware.middleware,
  listenerMiddleware.middleware,
  appListenerMiddleware.middleware,
  translationsMiddleware.middleware,
  authListenerMiddleware.middleware,
  gatesListenerMiddleware.middleware,
  kioskListenerMiddleware.middleware,
  onlinePaymentMiddleware.middleware,
  socketListenerMiddleware.middleware,
  refDataListenerMiddleware.middleware,
  healthCheckListenerMiddleware.middleware,
  selfServiceListenerMiddleware.middleware,
  vehicleCheckListenerMiddleware.middleware,
];

export const configStore = (
  withMiddlewares = true,
  withSentry = true,
  withPersist = true,
  preloadedState = {},
) => configureStore({
  reducer: withPersist ? persistedReducer : rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      ignoredActionPaths: ['meta.baseQueryMeta', 'meta.arg', /.*medias.*/],
      ignoredPaths: [/.*medias.*/],
    },
  }).concat(withMiddlewares ? MIDDLEWARES : []),
  enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(withSentry ? [sentryReduxEnhancer] : []),
  preloadedState,
});

export const store = configStore();
export const persistor = persistStore(store);

export type AppDispatch = typeof store.dispatch;
export { type RootState } from './rootReducer';
